import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCaterpillarComponent } from './simple-icons-caterpillar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCaterpillarComponent ],
    exports:      [ SimpleIconsCaterpillarComponent ],
    bootstrap:    []
})
export class SimpleIconsCaterpillarModule {}
